<template>
<div class="blank">
    <!-- <div class="cash-list">
        <img src="../assets/images/cash-header-bg.jpg" alt="">
        <ul>
            <li v-for="(item,index) in list" :key="index">
                <a :href="item.contentLink">
                    <img :src="item.pictureLink" />
                    <div class="cl-r">
                        <h2>{{item.contentName}}</h2>
                        <p class="blue-one">{{item.addContentOne}}</p>
                        <p>{{item.addContentTwo}}</p>
                        <p>{{item.addContentThree}}</p>
                    </div>
                    <i></i>
                </a>
            </li>
        </ul>
    </div> -->
    <!-- <loading v-show="isLoading"></loading> -->
    <!-- <iframe src="https://fin-app.zhongan.com/sh/event/diandian-mark/index.html#/activetmp?mod=Cash01" class="iframe_cash"></iframe> -->
    <div id="activetmp" class="activetmp">
        <!-- :class="{'clear-margin-top':!item.levelLTitle}" -->
        <div v-for="(item,index) in dataList" class="ap-container">
        <div @click="titleHandle(item)" v-if="item.levelLTitle" class="ap-header clearfix">
            <div class="ap-h-left">
                <p>{{item.levelLTitle}}</p>
            </div>
            <div class="ap-h-right">
                <a :href="item.levelTitleLink || 'javascript:void(0)'" v-if="item.levelRTitle">{{item.levelRTitle}}<i></i></a>
            </div>
        </div>
        <div class="ap-main">
            <!-- 循环子组件 -->
            <div v-for="(child,cIndex) in item.levelComponentList">
                <!-- 图片导航 -->
                <div v-if="child.componentType==100" class="ap-box">
                    <div v-for="(t,tIndex) in child.levelFieldList" class="ap-list" :class="'list'+child.levelFieldList.length">
                        <a @click="ilogHandle(item,t)" :href="t.fieldUrl || 'javascript:void(0)'"><img :src="t.fieldPicUrl" /></a>
                    </div>
                </div>
                <!-- 图文列表 -->
                <div v-if="child.componentType==120" class="tw-nav">
                    <!-- 单列 -->
                    <div v-if="child.componentPattern==100" v-for="(t,tIndex) in child.levelFieldList" class="tw-box">
                        <a @click="ilogHandle(item,t)" :href="t.fieldUrl || 'javascript:void(0)'">
                            <div class="t-left">
                                <img :src="t.fieldPicUrl" alt="">
                            </div>
                            <div class="t-right">
                                <div class="tr-text">
                                    <h2>{{t.fieldDesc}}</h2>
                                    <b>{{t.fieldParamSt}}</b>
                                    <p>{{t.fieldParamNd}}</p>
                                    <p>{{t.fieldParamRd}}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <!-- 双列 -->
                    <div v-if="child.componentPattern==110" class="sl-box clearfix clear-padding sl">
                        <div v-for="(t,tIndex) in child.levelFieldList" class="sl-list">
                            <a @click="ilogHandle(item,t)"  :href="t.fieldUrl || 'javascript:void(0)'">
                                <img :src="t.fieldPicUrl" />
                                <h2>{{t.fieldDesc}}</h2>
                                <p>{{t.fieldParamSt}}</p>
                                <p>{{t.fieldParamNd}}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- 轮播图 :class="{'clear-margin-top':!item.levelLTitle}" -->
                <div v-if="child.componentType==110" class="swiper" >
                    <swiper :options="swiperOption" ref="mySwiper">
                        <swiper-slide v-for="(t,tIndex) in child.levelFieldList" :key="index">
                            <a @click="ilogHandle(item,t)"  :href="t.fieldUrl || 'javascript:void(0)'">
                                <img v-if="t.fieldPicUrl" :src="t.fieldPicUrl" alt="">
                                <p class="big-num" v-if="!t.fieldPicUrl">{{tIndex+1}}</p>
                            </a>
                        </swiper-slide>
                        <div class="swiper-pagination my-swiper-pagination" slot="pagination"></div>
                        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div> -->
                    </swiper>
                </div>
                <div v-if="child.componentType==130" class="quill-editor my-quill-editor" >
                    <div class="ql-snow" v-for="(t,tIndex) in child.levelFieldList" :key="index">
                        <div class="ql-container ql-snow" >
                            <div v-html="decodeURIComponent(t.fieldTextArea)"class="ql-editor"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <img style="visibility: hidden;position:absolute;" :src="ilogSrc || 'javascript:void(0)'" />
    <toast v-show="isToast">
        <slot>{{toastMsg}}</slot>
    </toast>
    <loading v-show="isLoading"></loading>
</div>

</div>
</template>
<style lang="scss" scoped>
    @import '../assets/styles/all.scss';
    .cash-list{
        max-width: 640px;
        img{
            max-width: 100%;
        }
        background: #ffffff;
        ul{
            box-sizing: border-box;
            padding-left: r(15);
            li{
                // display: -webkit-box;
                border-bottom: 0.5px solid rgb(230,230,230);
                padding: r(15) 0;
                position: relative;
                a{
                    display: -webkit-box;
                    -webkit-box-align: center;
                    width: 100%;
                    height: r(80);
                }
                img{
                    // float: left;
                    width: r(62);
                    height: r(62);
                    vertical-align: middle;
                }
                i{
                    display: inline-block;
                    width: r(7);
                    height: r(12);
                    background: url('../assets/images/link.png') no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    top: 50%;
                    -webkit-transform:translateY(-50%);
                    right: r(15);
                    z-index: 2;
                }
            }
            li:last-child{
                border-bottom: none;
            }
        }
        .cl-r{
            max-width: r(260);
            position: relative;
            overflow: hidden;
            -webkit-box-flex: 1;
            padding-left: r(10);
            padding-top: r(2);
            h2{
                font-size: r(15);
                font-weight: 500;
                color: rgb(51,51,51);
            }
            p{
                line-height: r(16);
                font-size: r(12);
                color: rgb(167,167,167);
            }
            .blue-one{
                color: rgb(85,166,255)
            }
        }
    }

    .iframe_cash{
        position: absolute;
        left: 0;
        top: 0;
        border: none;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
    }

    .fade-canvas-enter-active{
    transition: opacity 0.5s;
    }
    .fade-canvas-enter{
        opacity: 0;
    }

    .activetmp{
        min-height: 100%;
        background: #fff;
        background: rgb(246,246,246);
        position: relative;
        overflow: hidden;
        .ap-container{
            margin-top: r(10);
            background: #ffffff;
            font-size: r(15);
            min-height: 100%;
            .ap-header{
                padding-top: r(10);
                padding-bottom: r(10);
                margin-bottom: r(10);
                position: relative;
                .ap-h-left,.ap-h-right{
                    width: 50%;
                    float: left;
                    box-sizing: border-box;
                }
                .ap-h-left{
                    padding-left: r(24);
                    text-align: left;
                    p{
                        color: rgb(70,70,70);
                        font-weight: 400;
                        position: relative;
                    }
                    p::before{
                        content:"";
                        left: r(-8);
                        top:r(3);
                        width: r(5);
                        height: r(15);
                        background: rgb(85,166,255);
                        position: absolute;
                    }
                }
                .ap-h-right{
                    a{
                        float: right;
                        font-size: r(13);
                        padding-right: r(15);
                        text-align: right;
                        color: rgb(167,167,167);
                        i{
                            display: inline-block;
                            vertical-align: middle;
                            margin-top: r(-2);
                            margin-left: r(5);
                            width: r(8);
                            height: r(14);
                            // background: url('../images/icon-apply-right-arrow.png') no-repeat;
                            background-size: r(8) r(14);
                        }
                    }
                }
            }
            .ap-header::before{
                content:"";
                left: 50%;
                -webkit-transform:translateX(-50%) scaleY(0.5);
                bottom:r(0);
                width: 95%;
                height: r(1);
                background: rgb(230,230,230);
                position: absolute;
            }
            .ap-main{
                position: relative;
                // overflow: hidden;
                padding: r(5) 0;
                .ap-box{
                    display: -webkit-box;
                    box-sizing: border-box;
                    padding: r(0) r(15);
                    margin-top: r(-10);
                    -webkit-box-pack: justify;
                    .ap-list{
                        a{
                            display: block;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .ap-list{
                    margin-top: r(10);
                    margin-bottom: r(10);
                    img{
                        border: none;
                    }
                }
                .list4{
                    margin-top: r(10);
                    margin-bottom: r(10);
                    // 60
                    width: r(79);
                    height: r(94);
                    img{
                        width: 100%;
                        height: 100%;
                        display: block;
                        // background: #e9d1d1;
                    }
                }
                .list3{
                    width: r(108);
                    height: r(158);
                    img{
                        width: 100%;
                        height: 100%;
                        display: block;
                        // background: #e7e9d1;
                    }
                }
                .list2{
                    width: r(167);
                    height: r(104);
                    img{
                        width: 100%;
                        height: 100%;
                        display: block;
                        // background: #d9e9d1;
                    }
                }
                .list1{
                    width: 100%;
                    height: r(110);
                    img{
                        width: 100%;
                        height: 100%;
                        display: block;
                        // background: #d1e9e9;
                    }
                }
                .sl{
                    .sl-box{
                        margin-top: r(10);
                    }
                    .sl-list{
                        box-sizing: border-box;
                        text-align: center;
                        height: r(172);
                        width: 50%;
                        float: left;
                        padding: r(20) r(10);
                        position: relative;
                        a{
                            display: block;
                            width: 100%;
                            height: 100%;
                        }
                        img{
                            width: r(62);
                            height: r(62);
                            vertical-align: top;
                        }
                        h2,p{
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                        }
                        h2{
                            padding-top: r(10);
                            font-size: r(15);
                            color: rgb(51,51,51);
                            font-weight: 400;
                        }
                        p{
                            font-size: r(12);
                            color: rgb(167,167,167);
                        }
                    }
                    .sl-list:nth-child(odd)::before{
                        content: "";
                        position: absolute;
                        width: 1px;
                        height: 120%;
                        top:0;
                        right: 0;
                        background: rgb(230,230,230);
                        -webkit-transform:scaleX(0.5);
                    }
                    .sl-list:nth-child(odd)::after{
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        left: 0;
                        bottom: 0;
                        background: rgb(230,230,230);
                        -webkit-transform:scaleY(0.5);
                    }
                    .sl-list:nth-child(even)::after{
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        left: 0;
                        bottom: 0;
                        background: rgb(230,230,230);
                        -webkit-transform:scaleY(0.5);
                    }
                }
                .clear-padding{
                    padding: 0;
                }

            }

            .swiper{
                height: r(110);
                // background: #d1d6e9;
                margin-top: r(-10);
                margin-bottom: r(10);
                position: relative;
                .swiper-container{
                    height: 100%;
                    position: relative;
                    overflow: hidden;;
                    .swiper-wrapper{
                        height: 100%;
                        .swiper-slide{
                            width: 100%;
                            height: 100%;
                            a{
                                width: 100%;
                                height: 100%;
                            }
                            img{
                                display: block;
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
                .swiper-container-horizontal > .swiper-pagination-bullets{
                    bottom: r(3);
                }
            }

            .tw-nav{
                margin-top: r(-10);
                margin-bottom: r(10);
                position: relative;
                overflow: hidden;
                .tw-box{
                    a{
                        display: block;
                        width: 100%;
                        height: 100%;
                        height: r(96);
                        box-sizing: border-box;
                        margin-left: r(15);
                        padding-top: r(10);
                        padding-bottom: r(10);
                        width: 100%;
                        position: relative;
                        display: -webkit-box;
                        -webkit-box-align: center;
                    }
                    a::before{
                        content: "";
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        -webkit-transform:scaleY(0.5);
                        background: rgb(230,230,230);
                        left: 0;
                        bottom: 0;
                    }

                    .t-left{
                        font-size: 0;
                        img{
                            width: r(105);
                            height: r(66);
                            // background: #d6b7e3;
                        }
                    }
                    .t-right{
                        width: r(258);
                        box-sizing: border-box;
                        padding-left: r(15);
                        padding-right: r(15);
                        h2,b,p{
                            display: block;
                            // padding-bottom: r(5);
                            width: 100%;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                            // overflow: hidden;
                        }
                        b,p{
                            line-height: r(18);
                        }
                        h2{
                            font-size: r(16);
                            font-weight: 400;
                            color: rgb(51,51,51);
                        }
                        b{
                            font-size: r(12);
                            color: rgb(85,166,255);
                        }
                        p{
                            font-size: r(12);
                            color: rgb(167,167,167);
                        }
                    }
                }
                // .tw-box::after{
                //     content:"";
                //     position: absolute;
                //     left: r(15);
                //     bottom: 0;
                //     width: 100%;
                //     height: r(1);
                //     background: rgb(230,230,230);
                //     -webkit-transform:scaleY(0.5);
                // }
                .tw-box:last-child{
                    a::before{
                        content: "";
                        display: none;
                    }
                }
            }

        }
        .ap-container:first-child{
            margin-top: 0;
        }
        .clear-margin-top{
            margin-top: 0 !important;
        }

        .my-quill-editor{
        .ql-container.ql-snow{
            border:none !important;
        }
        .ql-video{
            height: r(195);
            width: r(410);
            margin: 0 auto;
            border: 1px solid #efefef;
        }
    }

    }

    .win-load-mark{
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background:rgba(255,255,255,0.85);
        z-index: 2;
        img{
            position: relative;
            left: 50%;
            top: 50%;
            -webkit-transform:translate(-50%,-50%)
        }
    }

</style>
<script>
import {
    Group,
    Cell
} from 'fiui'
import {
    list
} from '../utils/faq.js'
import storage from '../utils/storage'
import Loading from '../components/loading';
import Toast from '../components/toast';
import {api} from '../api/axios';
import {getNow,randomString}  from '../utils/tool';

export default {
    data() {
        return {
            list: [],
            isLoading:false,
            toastMsg: '',
            isToast:false,
            ilogSrc: '',
            isVersioning: false,
            dataList:'',
            isWinLoadMark:false,
            columnLink:'',
            documentTitle:'',
            isLoading:true
        }
    },
    components: {
        Group,
        Cell,
        Loading,
        Toast
    },
    watch: {
        isToast(n, o) {
            if (n == true) {
                setTimeout(() => {
                    this.isToast = false;
                }, 2000)
            }
        }
    },
    created() {

    },
    beforeRouteEnter(to, from, next) {
        document.title = '我要现金'
        next()
    },
    mounted() {
        window.location.href = 'https://diandian.qingchunbank.com/diandian-common-schedule/index.html#/authstatus?isGuide=1'
        // let columnLink=window.location.href
        // let columnLink = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/cashlist'
        // if(columnLink.indexOf('http://localhost:')>-1){
        //     columnLink='https://one-test.zhongan.com/fcp/diandian/#/cashlist'
        // }
        //
        // api({
        //     id: 'cmsAPI.pagedQueryColumnContents',
        //     param: {
        //         'columnLink':columnLink,
        //         'contentStatus':0,
        //         "pageInfo": {
        //             "currentPage": 1,
        //             "pageSize": 100
        //         }
        //     }
        // }).then((res) => {
        //     if (res.data.status == "SUCCESS") {
        //         this.isLoading = false;
        //         if (res.data.code == 1) {
        //             //成功
        //             var data = res.data.data.dataList
        //             console.log(data);
        //             this.list=data
        //         } else {
        //             this.toastMsg = data.message;
        //             this.isToast = true;
        //         }
        //     }
        // }).catch((error) => {
        //     this.toastMsg = '请求失败';
        //     this.isToast = true;
        //     this.isLoading = false;
        // })

        // api({
        //     id: 'cmsAPI.pagedQueryCmsLevel',
        //     param: {
        //         "partnerNo": "NYDDXJD",
        //         "columnUrl": "https://fin-app.zhongan.com/sh/event/diandian-mark/index.html#/activetmp?mod=Cash01",
        //         "columnNewStatus":"0",
        //         "levelStatus":1000,
        //         "pageInfo": {
        //             "currentPage": 1,
        //             "pageSize": 1000
        //         },
        //         "reqNo": randomString(20),
        //         "reqDate": getNow()
        //     }
        // }).then((res) => {
        //     if (res.status == 200) {
        //         this.isLoading=false
        //         var data = res.data
        //         if (data.code == 1) {
        //             //成功
        //             var dataList=data.data.dataList
        //             this.dataList=dataList.filter((e)=>{
        //                 return e.levelStatus==1000
        //             })
        //
        //             if(this.dataList.length==0){
        //                 this.toastMsg = '暂无数据';
        //                 this.isToast = true;
        //                 return
        //             }
        //             // document.title=this.dataList[0].columnName
        //         } else {
        //             this.toastMsg = data.message;
        //             this.isToast = true;
        //         }
        //     }
        // }).catch((error) => {
        //     this.toastMsg = '请求失败';
        //     this.isToast = true;
        //     this.isLoading = false;
        // })

    },
    methods: {
        ilogHandle(item,t){

        }
    }
}
</script>



// WEBPACK FOOTER //
// cashlist.vue?37f56d46